export const pageSectionName = {
    none: 'none',
    adminPanelDetails: 'adminPanelDetails',
    adminPanelEdit: 'adminPanelEdit',
    accountCreate: 'accountCreate',
    accountDetails: 'accountDetails',
    accountEdit: 'accountEdit',
    activityCreate: 'activityCreate',
    activityDetails: 'activityDetails',
    activityEdit: 'activityEdit',
    claimCreate: 'claimCreate',
    claimDetails: 'claimDetails',
    claimEdit: 'claimEdit',
    claimActionCreate: 'claimActionCreate',
    claimActionDetails: 'claimActionDetails',
    claimActionEdit: 'claimActionEdit',
    creditTypeCreate: 'creditTypeCreate',
    creditTypeDetails: 'creditTypeDetails',
    creditTypeEdit: 'creditTypeEdit',
    categoryCreate: 'categoryCreate',
    categoryDetails: 'categoryDetails',
    categoryEdit: 'categoryEdit',
    contactCreate: 'contactCreate',
    contactDetails: 'contactDetails',
    contactEdit: 'contactEdit',
    contactTypeCreate: 'contactTypeCreate',
    contactTypeDetails: 'contactTypeDetails',
    contactTypeEdit: 'contactTypeEdit',
    domainCreate: 'domainCreate',
    domainDetails: 'domainDetails',
    domainEdit: 'domainEdit',
    domainUserCreate: 'domainUserCreate',
    domainUserDetails: 'domainUserDetails',
    domainUserEdit: 'domainUserEdit',
    imageDetails: 'imageDetails',
    imageEdit: 'imageEdit',
    functionCreate: 'functionCreate',
    functionDetails: 'functionDetails',
    functionEdit: 'functionEdit',
    functionMemberDetails: 'functionMemberDetails',
    functionMemberEdit: 'functionMemberEdit',
    messageCreate: 'messageCreate',
    messageDetails: 'messageDetails',
    messageEdit: 'messageEdit',
    noticeCreate: 'noticeCreate',
    noticeDetails: 'noticeDetails',
    noticeEdit: 'noticeEdit',
    observationTypeCreate: 'observationTypeCreate',
    taskTypeCreate: 'taskTypeCreate',
    observationTypeDetails: 'observationTypeDetails',
    taskTypeDetails: 'taskTypeDetails',
    observationTypeEdit: 'observationTypeEdit',
    taskTypeEdit: 'taskTypeEdit',
    projectCreate: 'projectCreate',
    projectDetails: 'projectDetails',
    projectEdit: 'projectEdit',
    projectMemberCreate: 'projectMemberCreate',
    projectMemberDetails: 'projectMemberDetails',
    projectMemberEdit: 'projectMemberEdit',
    pageCreate: 'pageCreate',
    pageDetails: 'pageDetails',
    pageEdit: 'pageEdit',
    pageComponentCreate: 'pageComponentCreate',
    pageComponentDetails: 'pageComponentDetails',
    pageComponentEdit: 'pageComponentEdit',
    roleCreate: 'roleCreate',
    roleDetails: 'roleDetails',
    roleEdit: 'roleEdit',
    taskCreate: 'taskCreate',
    taskDetails: 'taskDetails',
    taskEdit: 'taskEdit',
    themeCreate: 'themeCreate',
    themeDetails: 'themeDetails',
    themeEdit: 'themeEdit',
    userCreate: 'userCreate',
    userDetails: 'userDetails',
    userEdit: 'userEdit',
} as const;

export type PageSectionName = typeof pageSectionName[keyof typeof pageSectionName];
